import utils from '../../../../modules/utils';
import API from '../../../api/api';

function isTokenReceived(status) {
  return status === 'HOSTED_PAYMENT_TOKEN_RECEIVED';
}

function isReturningFromHostedPage() {
  return window.start.selectedPaymentMethod === 'AMAZONPAY';
}

function isProblemWithService(status) {
  return (status === 'HOSTED_PAYMENT_AUTHENTICATION_FAILED'
    || status === 'HOSTED_PAYMENT_CURRENTLY_UNAVAILABLE');
}

function returnedFromHostedPage(queryParams) {
  const amazonCheckoutSessionId = utils.fn.getURIParam(queryParams, 'amazonCheckoutSessionId') || '';
  return API.doAPIRequest(`/v2/return-from-hosted/amazonpay?status=SUCCESS&amazonpayCheckoutSessionId=${amazonCheckoutSessionId}`);
}

export default {
  isTokenReceived, isProblemWithService, isReturningFromHostedPage, returnedFromHostedPage,
};
